import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { T } from './strings';

const LanguageContext = createContext({ lang: 'en', setLang: () => {}, t: (k) => k });

const readSaved = () => {
  try { return localStorage.getItem('kc-lang') === 'bn' ? 'bn' : 'en'; } catch (e) { return 'en'; }
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(readSaved);

  useEffect(() => {
    try { localStorage.setItem('kc-lang', lang); } catch (e) { /* private mode: keep it for this visit only */ }
    document.documentElement.lang = lang;
    document.body.classList.toggle('bn', lang === 'bn');
  }, [lang]);

  const value = useMemo(() => ({
    lang,
    setLang,
    t: (key) => (T[lang][key] !== undefined ? T[lang][key] : T.en[key] !== undefined ? T.en[key] : key),
  }), [lang]);

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);
